module.exports = __webpack_public_path__ + "static/media/icon-instagram-threads.2570490c.svg";